/**
 * Moment Timezone 0.5.33-2021a
 * https://momentjs.com/timezone/
 * 
 */
import moment from 'moment-timezone';

export const dateFormat = {
    date: 'YYYY-MM-DD', 
    dateTime :'YYYY-MM-DD HH:mm'
}


// get current time zone 
export const TIMEZONE = moment.tz.guess();
/**
 Moment Timezone uses the Internationalization API (Intl.DateTimeFormat().resolvedOptions().timeZone) 
 in supported browsers to determine the user's time zone.
/**

* return Converted date with local timezone
 */
export const getDate = (date) =>(date? moment(date).tz(TIMEZONE) : null);
/**
 * Return formated date mm/dd/yyy
 */

function convertTZ(date, tzString) {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));   
}

export const formatedDate = (date, format = dateFormat.date) => (date ? moment(date).tz(TIMEZONE).format(format) : null);
export const formatedDateTime = (date, format = dateFormat.dateTime) => {
    if( date) {
        let d = date ? date.replace('T', ' ') :null;
        let dateTime = convertTZ(`${d} +0000`, TIMEZONE).toString();
        dateTime = moment(dateTime).format(format) 
        return dateTime;
    } else {
        return 'N/A';
    }

}